/* eslint no-underscore-dangle: ["error", { "allowAfterThis": true  }] */
import { REST_URI } from 'lib/appConfig';
import { SocketChannel } from './SocketChannel';

const event = {
  CHANNEL_UPDATE: 'channel_update',
};

const ENDPOINT = `${REST_URI}/events/firstarticleinspection`;

class FAISocket {
  constructor({ companyId, machineRef, workOrderOperationRef }) {
    this._onUpdate = null;
    this._handleChannelUpdate = (data) => {
      if (this._onUpdate) {
        this._onUpdate(data);
      }
    };

    this.socket = new SocketChannel({
      url: ENDPOINT,
      joinParams: { companyId, machineRef, workOrderOperationRef },
    });

    // Register before join completes (same pattern as AnnotationsSocket / ShiftSocket).
    this.socket.on(event.CHANNEL_UPDATE, this._handleChannelUpdate);
  }

  subscribe(onData) {
    this._onUpdate = onData;
  }

  leave() {
    this._onUpdate = null;
    this.socket.off(event.CHANNEL_UPDATE, this._handleChannelUpdate);
    this.socket.disconnect();
  }
}

export { FAISocket };
